
import React, { useState } from 'react'
import { TbChevronDown, TbChevronUp } from 'react-icons/tb'
import Button from '../Reusable/Button'
import { faq } from './tab/FaqData'

const FAQ = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const handleOpen = (index) => {
        setOpenIndex(prevIndex => (prevIndex === index ? null : index));
    };

    return (
        <div data-aos="fade-left" className='flex flex-col bg-[#161616] py-[7%] lg:px-[8%] gap-5 px-[4%] z-[500] relative'>
            <p className='text-[100px] z-[100] lg:block hidden top-[50px] left-[30%] absolute text-white font-bold text-opacity-5'>QUESTIONS?</p>
            <div className='flex w-full items-center justify-center'>
                <div className='lg:w-[55%] gap-4 w-full flex flex-col items-center justify-center'>
                    <p className='lg:text-[40px] text-[25px] text-white font-semibold '>Frequently Asked Questions</p>
                    <p className='text-[14px] text-[#ffffff] text-center'>Each product is crafted to optimize efficiency, enhance sustainability, and support fair trade practices across the globe.</p>
                </div>
            </div>
            <div className='flex flex-col gap-4 lg:px-[14%]'>
                <div className='w-full grid grid-cols-1 justify-between gap-6'>
                    {faq.map((f, i) => (
                        <div key={i} className='flex flex-col justify-between items-center border-[1px] border-blue-400 w-full p-3 rounded-lg'>
                            <div onClick={() => handleOpen(i)} className='flex p-3 cursor-pointer justify-between items-center w-full'>
                                <p className='font-bold text-[14px] text-white'>{f.question}</p>
                                <div className='w-[30px] h-[20px] flex items-center justify-center rounded-md bg-blue-200 border-[1px] border-blue-400'>
                                    {openIndex === i ? <TbChevronUp /> : <TbChevronDown />}
                                </div>
                            </div>
                            {openIndex === i && (
                                <div className='flex flex-col gap-3 mt-2 w-full'>
                                    {/* <img src="/Blockfarm/Line 3.svg" className='w-full important' alt="" /> */}
                                    <hr className='w-full h-[2px] bg-blue-600' />
                                    <p className='text-[14px] bor text-white text-opacity-75'>{f.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
                <div className='flex w-full justify-center items-center'>
                    <Button title={"See all"} link={"/"} />
                </div>
            </div>
        </div>
    );
}

export default FAQ;
